import React from 'react';

import type { Section } from '../../../../../models';
import UtilitiesAnnualCosts from './UtilitiesAnnualCosts';
import { ELECTRICITY } from '../../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function ElectricityAnnualCosts({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesAnnualCosts
      section={section}
      setSectionValues={setSectionValues}
      annualCostsField={ELECTRICITY.FIELD_NAME.ANNUAL_COSTS}
      utilityName="Electricity"
      knowAnnualCostsUtilityProviderField={ELECTRICITY.FIELD_NAME.KNOW_ANNUAL_COSTS_UTILITY_PROVIDER}
    />
  );
}

export default ElectricityAnnualCosts;
